<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M7 14.2c-.55 0-1.02-.2-1.41-.59-.4-.39-.59-.86-.59-1.41 0-.55.2-1.02.59-1.41.39-.4.86-.59 1.41-.59.55 0 1.02.2 1.41.59.4.39.59.86.59 1.41 0 .55-.2 1.02-.59 1.41-.39.4-.86.59-1.41.59Zm0 4a5.79 5.79 0 0 1-4.25-1.75A5.79 5.79 0 0 1 1 12.2c0-1.67.58-3.08 1.75-4.25A5.79 5.79 0 0 1 7 6.2c1.12 0 2.13.27 3.04.82.9.55 1.63 1.28 2.16 2.18H21l3 3-4.5 4.5-2-1.5-2 1.5-2.13-1.5H12.2a6.21 6.21 0 0 1-2.16 2.18c-.91.55-1.92.82-3.04.82Zm0-2a4.03 4.03 0 0 0 3.88-3H14l1.45 1.03 2.05-1.53 1.77 1.38 1.88-1.88-1-1h-9.27A4.03 4.03 0 0 0 7 8.2c-1.1 0-2.04.4-2.83 1.17A3.85 3.85 0 0 0 3 12.2c0 1.1.4 2.04 1.17 2.83A3.85 3.85 0 0 0 7 16.2Z"
      />
    </svg>
  </span>
</template>
